import { SlateEditor } from '@src/components/sco/RichMarkdownInput'
import { toggleMark } from '@src/components/sco/RichMarkdownInput/utilities/marks'
import { isHotkey } from 'is-hotkey'

type HotKeyConfig = {
  [hotkey: string]: {
    mark?: string
    func?: (event: KeyboardEvent) => void
  }
}

export const MARK_HOTKEYS: HotKeyConfig = {
  'mod+b': { mark: 'bold' },
  'mod+i': { mark: 'italic' },
  'mod+u': { mark: 'underline' },
  'mod+`': { mark: 'code' },
}

export function withMarkHotKeys(
  editor,
  options: {
    hotKeys?: HotKeyConfig[]
  } = {}
) {
  const { onKeyDown } = editor

  const hotKeys = {
    ...MARK_HOTKEYS,
    ...options.hotKeys,
  }

  editor.onKeyDown = (editor: SlateEditor, event) => {
    for (const hotkey in hotKeys) {
      if (isHotkey(hotkey, event as any)) {
        event.preventDefault()
        if (hotKeys[hotkey].mark) {
          const mark = hotKeys[hotkey].mark
          toggleMark(editor, mark)
        }
        if (hotKeys[hotkey].func) {
          hotKeys[hotkey].func(event)
        }
      }
    }

    if (onKeyDown) {
      onKeyDown(editor, event)
    }
  }

  return editor
}
